var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueDatePicker',{attrs:{"disabled-picker":_vm.disabled,"format":"dd/MM/yy","value":_vm.value || Date.now()},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }